// extracted by mini-css-extract-plugin
export default {"wrapper":"navigationTabs_wrapper__-hew0","tab":"navigationTabs_tab__HmHHn","tabActive":"navigationTabs_tabActive__tj8w7","fade-in":"navigationTabs_fade-in__v-v26"};